<template>
  <section class="primaryInfo">
    <a
      name="home"
      style=" position: relative;top: -420px;display: block;height: 0;overflow: hidden;"
    ></a>
    <section class="information">
      <section class="innerBox">
        <div class="leftMenu">
          <li
            @click="gotoHandle(leftItem.anchorId)"
            :class="[
              'menu-item',
              isActive === leftItem.anchorId ? 'menu-item--active' : ''
            ]"
            v-for="(leftItem, idx) in leftMenus"
            :key="idx"
          >
            {{ leftItem.title }}
          </li>
        </div>
        <div class="info">
          <h1>PayBy Privacy Policy</h1>
          <h3>Last updated: March, 18 2020</h3>
          <!-- <h3>Last updated: August 2019 </h3> -->

          <p>
            <strong
              >ToTok Technology Ltd and PayBy Technology Projects LLC</strong
            >
            (together, "<strong>PayBy</strong>", "<strong>we</strong>",
            "<strong>us</strong>" or "<strong>our</strong>") are committed to
            protecting and respecting your privacy and personal data. This
            privacy policy sets out the basis on which any personal data we
            collect from you, or that you provide to us, through the use of our
            payments services ("<strong>PayBy Services</strong>") as
            provided via our instant messaging application ToTok
            ("<strong>ToTok</strong>" or the "<strong>App</strong>"), will be
            processed by us. Please read the following information carefully to
            fully understand our views and practices regarding your personal
            data and how we will treat it. For information regarding the general
            use of the PayBy Services, please see our
            <a href="/totokpayterms">Terms of Use</a>. For information regarding
            the use of the App or the privacy practices more generally, please
            visit <a href="/terms">ToTok Terms of Use</a> and
            <a href="/privacy">ToTok Privacy Policy</a>.
          </p>

          <p>
            If you wish to contact us with any questions in relation to this
            policy or our privacy practices, you may contact us in writing at
            the address given above or by emailing
            <a mailto="privacy@totok.ai">privacy@totok.ai</a> or by contacting
            us via the App.
          </p>
          <p>
            At all times, we keep our privacy practices and the terms of this
            policy under review to ensure your personal data is processed as
            securely as possible. This policy was last updated on the date given
            above. Any changes to this policy will be posted online, within the
            App and, if possible, emailed to you.
          </p>
          <h2>1. Information We May Collect From You</h2>
          <p>
            Personal data, or personal information, means any information about
            an individual from which that person can be identified. To provide
            you with the PayBy Services, we must collect, store, transfer,
            analyse and otherwise process certain of your personal data.
          </p>
          <p>The personal data we process includes:</p>
          <ul>
            <li>
              <strong
                >Account data for the PayBy Services that we receive from
                ToTok:</strong
              >
              as you have an account with ToTok and we require certain of the
              personal data used by ToTok to provide the PayBy Services, we
              automatically receive certain personal data from ToTok when you
              start to open a PayBy account. This personal data is limited
              to your name, mobile number and ToTok UID.
            </li>
            <li>
              <strong
                >Account data for PayBy Services that you provide us when we
                require to verify your identity:</strong
              >
              for us to provide you with the PayBy Services, we must be able
              to verify your identity and we will prompt you when verification
              is required. To do this, we require you provide us with your
              Emirates ID and any other document we may request From such
              documents, we will collect your name, date of birth, Emirates ID
              expiration date and any other personal data we consider necessary
              or that which is required by law to verify your identity. We will
              also request that you provide a “real time” video recording of
              yourself, including audio, which you will prompted to provide in
              the App. Please note that to record the “real time” video, we will
              require access to the camera and microphone on your device. If we
              cannot access such functions, we cannot verify your identity and
              therefore cannot provide you with an account.
            </li>
            <li>
              <strong
                >Account data for PayBy Services which we will request your
                consent for:</strong
              >
              when preparing your account with PayBy, we will also ask if
              you would like nickname, Avatar and other user personal data from
              your ToTok account to be transferred to your PayBy Account.
              This is not required to register your account but will enhance
              your user experience whilst operating PayBy Services.
            </li>
            <li>
              <strong>Transaction data:</strong> when you use our PayBy
              Services to either make purchases from merchants, to receive
              money, to process payments, to pay for items, or to send money to
              friends and family, or for any other transactional purpose related
              to the PayBy Services, we collect information about the
              transaction, as well as other information associated with the
              transaction such as amount sent or requested, amount paid for
              products or services, merchant information. Specifically:
              <ul>
                <li>
                  <strong>Send or request money:</strong> when you send or
                  request money through the PayBy Services, we collect
                  personal data such as your name, account number, and the
                  financial account information about the participant who is
                  receiving money from you or sending money to you.
                </li>
                <li>
                  <strong>Pay for items from our listed merchants:</strong> when
                  you purchase items, such as a coffee, from one of our listed
                  merchants, we will collect personal data about your
                  transaction including your name, the merchant, and your
                  location.
                </li>
                <li>
                  <strong>Pay or request someone else to pay a bill:</strong> if
                  you use our PayBy Services to pay a bill for the benefit
                  of someone else, or if you request another user pay a bill for
                  you, we collect your ToTok UID and certain personal data about
                  the account holder, such as name, mobile number and account
                  number, of the bill that you intend to pay or request to be
                  paid.
                </li>
                <li>
                  <strong>Add value to your accounts:</strong> if you use our
                  PayBy Services to add value to your account, or if you ask
                  a user to add value to your account, we may collect personal
                  data from you about the other party, or from the other party
                  about you to facilitate the request. For example, if you use
                  our Services to reload a mobile phone, or to request value be
                  added to your mobile account, we may collect personal data and
                  other information including mobile account number from the
                  other participant.
                </li>
              </ul>
            </li>
            <li>
              <strong>Other financial data:</strong> when you wish to add value
              to your PayBy account, you may can do so by linking an account
              of yours that is separate from PayBy that has the ability to
              transfer funds into your ToTok account. We will ask if you would
              like to store this card information to make it is simpler in the
              future to add value to your PayBy account but you are not
              required to do so. We will not store such information if you do
              not provide your consent,
            </li>
            <li>
              <strong>Address book data:</strong> we may request access to your
              device address book which, if granted, will allow us to access
              your contacts. If we have access, we can tell you which of your
              contacts is also using PayBy Services to make the experience
              more beneficial for you, for example if we have access to your
              address book, it is simple for you to select a contact from your
              address book to start a conversation with.
            </li>
            <li>
              <strong>Data from other users:</strong> we will collect your
              personal data when other users of the PayBy Services interact
              with you, for example when they send you a request a request for
              payment. Further, such as when we access your address book with
              your consent as noted above, if another user of the PayBy
              Services has your details in their address book and provides us
              consent to access, we will have access to your personal data.
            </li>
            <li>
              <strong>Query or complaint data:</strong> should you wish to ask
              us a query or make a complaint about our PayBy Services, such
              personal data will also be automatically added to your account.
            </li>
            <li>
              <strong
                >Data from service providers and automated decision
                making:</strong
              >
              PayBy uses a third party to assist with its verification
              checks. Once the verification process has produced a result, this
              will be provided to PayBy and can be considered your personal
              data. Please note that the methods for verification checks
              operated by us and our partner involve automated decision making.
              Automated decision making is a process whereby your personal data
              is processed to make an evaluation with respect to you – in this
              case, your identity. Should the automated decision making process
              determine you have not properly validated your identity, you will
              not be granted an account.
            </li>
            <li>
              <strong>Technical, usage and cookie data</strong>: we collect
              information about your use of the PayBy Services, including
              how you use our PayBy Services, how often you use our ToTok
              Pay Services, the types of interactions you frequently use our
              PayBy Services for. We do this to better understand how to
              provide the PayBy Services, what our users like about our
              PayBy Services and what our users don’t like about the ToTok
              Pay Services. Such information may include, if applicable, your
              preferences, such as your language preference, internet protocol
              (IP) address, your account login data, browser type and version,
              browser plug-in types and versions.
            </li>
            <li>
              <strong>Device information</strong>: we collect information about
              the device you use to access the PayBy Services including the
              hardware model, the version of the App you are using, the mobile
              network, and the time zone setting.
            </li>
          </ul>
          <h2>2. How We Use Your Personal Data</h2>
          <p>We use your personal data for the following reasons:</p>
          <ul>
            <li>to verify your identity and create your account;</li>
            <li>
              to provide you with, and operate, the PayBy Services,
              including:
            </li>
            <ul>
              <li>
                to initiate a payment, send or request money, pay for an item,
                add value to an account, or pay a bill;
              </li>
              <li>
                create an account connection between your PayBy account and
                a separate third-party account or platform used to add value to
                your account; and
              </li>
              <li>
                perform creditworthiness and other financial standing checks,
                evaluate applications, and compare information for accuracy and
                verification purposes;
              </li>
            </ul>
          </ul>
          <ul>
            <li>
              for anti-fraud and risk identification and management purposes. We
              use your personal data to comply with legal obligations relating
              to fraud and other financial crimes, and to ensure you, your
              personal data and your finances are protected;
            </li>
            <li>
              to verify activity, and to promote safety and security on and off
              our PayBy Services. Should we believe you have breached our
              Terms of Use for either PayBy Services or for the use of
              ToTok, or are acting suspiciously, we may conduct an investigation
              to ensure you are not breaking the law;
            </li>
            <li>
              to communicate with you about your account, including with respect
              to any potential fraudulent activity;
            </li>
            <li>
              to send you marketing materials, including in relation to other
              products and services provided by our group companies;
            </li>
            <li>to respond to any of your queries;</li>
            <li>to improve and customise our PayBy Services.</li>
          </ul>
          <p>
            We only process your personal data when it is lawful for us to do
            so. We rely on the following lawful grounds under the GDPR to
            process your personal data:
          </p>

          <ul>
            <li>
              if you provide your consent, for example with respect to receiving
              marketing communications, allowing us to access your address book,
              or storing your financial information related to other accounts;
            </li>
            <li>
              the performance of the Terms of Use, which is a contract, you
              agree to when using our PayBy Services, for example to provide
              you with the PayBy Services;
            </li>
            <li>
              compliance with a legal obligation to which we are subject, for
              example to verify your identity;
            </li>
            <li>
              to protect your vital interests or those of another natural
              person, for example if we are investigating a report of harmful
              conduct submitted by you;
            </li>
            <li>
              performance of a task carried out in the public interest, for
              example to the extent this relates to the safety and security of
              our Service users and others; and/or
            </li>
            <li>
              the legitimate interests pursued by us or by a third party as
              listed below, subject at all times to us ensuring your rights and
              freedoms do not outweigh the pursued interests.
            </li>
          </ul>
          <p>The legitimate interests we pursue are:</p>
          <ul>
            <li>to constantly improve and customise our PayBy Services;</li>
            <li>
              to ensure the safety and security of our Service users and third
              parties, and to promote such safety and security; and
            </li>
            <li>
              to secure our PayBy Services from harmful acts such as
              cyber-security breaches.
            </li>
          </ul>
          <h2>3. Sharing Your Personal Data</h2>
          <p>
            We may share your personal data in the following scenarios only:
          </p>
          <ul>
            <li>we may share your personal data with your consent;</li>
            <li>
              we may share your personal data with other users who are using
              PayBy Services to ensure you both receive the full benefit of
              the PayBy Services offered. You also use our PayBy
              Services to share your own personal data with other users of the
              PayBy Services;
            </li>
            <li>
              by providing personal data to form part of your public profile on
              the App, any personal data displayed on the public profile will be
              visible by other users of the App;
            </li>
            <li>
              we may share your personal data with certain service providers,
              partners or group companies that facilitate and support us in
              providing the PayBy Services, including in relation to
              carrying out verification checks, remitting funds, and processing
              transactions. In certain circumstances, this will require us to
              share your full account and financial data, to the extent it
              relates to PayBy Services, with a partner due to the degree of
              support they provide;
            </li>
            <li>
              we may share your personal data with certain service providers or
              group companies to analyse our PayBy Services so we can
              improve and provide the best PayBy Services to you and others;
            </li>
            <li>
              we may share your personal data if we are required to respond to
              law enforcement, officials, regulatory agencies and other lawful
              requests or legal processes, or to comply with a legal obligation
              to which we are subject;
            </li>
            <li>
              we may share your personal data with if we undergo a merger,
              acquisition or other form or reorganisation and pursuant to such,
              a third party will become the controller of your personal data;
              and/or
            </li>
            <li>
              we may share your personal data with group companies if you
              request a good or service provided by one of our group companies,
              or if one of our group companies provides us with services which
              relate to the provision of PayBy Services to you.
            </li>
          </ul>
          <p>
            In accordance with the laws of the UAE, we will store your
            transaction and other account data within the UAE. Notwithstanding
            this, if we are required and permitted by law to transfer any of
            your personal data to a country outside that in which we collected
            it pursuant to the above listed circumstances, we will do so in
            accordance with the applicable data privacy legislation. The lawful
            requirements will depend on the flow of personal data, meaning it
            will depend on whether the sharing of personal data is cross-border
            and which countries are involved. At all times, we will ensure a
            similar degree of protection is afforded to your personal data
            outside the country in which you are based.
          </p>
          <h2>4. Security Of Your Personal Data</h2>
          <p>
            We take your privacy very seriously and work hard to protect your
            data from being accidentally lost, used or accessed in an
            unauthorised way, altered or disclosed. We have put in place
            appropriate security measures to prevent this from happening, for
            example we use encryption tools to protect the content of your
            messages and calls.
          </p>
          <p>
            In addition, we limit access to your personal data to those
            employees, volunteers, agents, contractors and other third parties
            (as listed above) who have a need to know. They will only process
            your personal data on our instructions and they are subject to a
            duty of confidentiality.
          </p>
          <p>
            Unfortunately, the transmission of information via the internet is
            not completely secure. Although we will do our best to protect your
            personal data, we cannot guarantee the security of your data
            transmitted through our PayBy Services; any transmission is at
            your own risk. Once we have received your information, we will use
            strict procedures and security features to try to prevent your data
            from being accidentally lost, used or accessed in an unauthorised
            way, altered or disclosed.
          </p>
          <h2>5. How Long we Keep Your Personal Data For</h2>
          <p>
            We will only retain your personal data for as long as reasonably
            necessary to fulfil the purposes we collected it for, including for
            the purposes of satisfying any legal, regulatory, tax, accounting or
            reporting requirements. To determine the appropriate retention
            period for personal data, we consider the amount, nature and
            sensitivity of the personal data, the potential risk of harm from
            unauthorised use or disclosure of your personal data, the purposes
            for which we process your personal data and whether we can achieve
            those purposes through other means, and the applicable legal,
            regulatory, tax, accounting or other requirements.
          </p>
          <p>With this in mind, we have determined that:</p>
          <ul>
            <li>
              as required by applicable law, particularly those that relate to
              anti-money laundering, we will store your financial data for ten
              years from the date of the transaction, or longer if subject to
              the below retention period; and
            </li>
            <li>
              upon cancelling your account, we will store all data related to
              your account, including personal data and transaction data, for up
              to five years from the date of cancellation before permanently
              deleting it.
            </li>
          </ul>
          <p>
            We may retain your personal data for a longer period in the event of
            a complaint or if we reasonably believe there is a prospect of
            litigation or other regulatory enforcement or action in respect to
            our relationship with you and/or your use of the PayBy Services.
          </p>
          <h2>6. Your Rights</h2>
          <p>
            In certain circumstances and subject to certain jurisdictional
            restrictions, you may have the right to:
          </p>
          <ul>
            <li>
              <strong>Request access</strong> to your personal data (commonly
              known as a "data subject access request"). This enables you to
              receive a copy of the personal data we hold about you and to check
              that we are lawfully processing it.
            </li>
            <li>
              <strong>Request correction</strong> of the personal data that we
              hold about you. This enables you to have any incomplete or
              inaccurate data we hold about you corrected, though we may need to
              verify the accuracy of the new data you provide to us.
            </li>
            <li>
              <strong>Request erasure</strong> of your personal data. This
              enables you to ask us to delete or remove personal data where
              there is no good reason for us continuing to process it. You also
              have the right to ask us to delete or remove your personal data
              where you have successfully exercised your right to object to
              processing (see below), where we may have processed your
              information unlawfully or where we are required to erase your
              personal data to comply with local law.
            </li>
            <li>
              <strong>Object to processing</strong> of your personal data where
              we are relying on a legitimate interest (or those of a third
              party) and there is something about your particular situation
              which makes you want to object to processing on this ground as you
              feel it impacts on your fundamental rights and freedoms. You also
              have the right to object where we are processing your personal
              data for direct marketing purposes.
            </li>
            <li>
              <strong>Request restriction of processing</strong> of your
              personal data. This enables you to ask us to suspend the
              processing of your personal data in certain scenarios.
            </li>
            <li>
              <strong>Request the transfer</strong> of your personal data to you
              or to a third party. We will provide to you, or a third party you
              have chosen, your personal data in a structured, commonly used,
              machine-readable format.
            </li>
            <li>
              <strong>Withdraw consent</strong> at any time where we are relying
              on consent to process your personal data.
            </li>
            <li>
              <strong>Complain</strong> to the appropriate regulator for any
              data protection issues. We would, however appreciate the chance to
              deal with your concerns before you approach the regulator so
              please contact us in the first instance.
            </li>
          </ul>
          <p>
            To exercise one of the above rights, please contact us using the
            details provided above.
          </p>
          <p>
            We may need to request specific information from you to help us
            confirm your identity and ensure you are able to exercise the right
            you wish to exercise. This is a security measure to ensure that
            personal data is not disclosed to any person who has no right to
            receive it. We may also contact you to ask you for further
            information in relation to your request to speed up our response.
          </p>
          <p>
            We try to respond to all legitimate requests within one month.
            Occasionally it could take us longer than a month if your request is
            particularly complex or you have made a number of requests. In this
            case, we will notify you and keep you updated.
          </p>
          <h2>7. Third Party Links</h2>
          <p>
            Our PayBy Services may include links to third-party websites,
            plug-ins and applications. Clicking on those links or enabling those
            connections may allow third parties to collect or share data about
            you. We do not control these third-party websites, plug-ins and/or
            applications and are not responsible for their privacy statements.
            When you leave our App, we encourage you to read the privacy policy
            of every website or application you visit or use.
          </p>
        </div>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Privacy Policy - ToTok Messenger",
      meta: [
        {
          Description:
            "To check how ToTok collect and process your data, please read our privacy policy carefully"
        },
        { property: "og:title", content: "Privacy Policy - ToTok Messenger" },
        { property: "og:url", content: "https://totok.ai/privacy" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png"
        },
        {
          property: "og:description",
          content:
            "Enjoy FREE, FAST and FUN calling with your family and friends."
        },
        { property: "og:site_name", content: "ToTok" }
      ]
    };
  },
  components: {},
  data() {
    return {
      archivedVersionLabel: "(archived versions)",
      mainPannel: "",
      showinfo: false,
      isActive: "totokpayprivacy",
      leftMenus: [
        {
          title: "Terms of Use",
          anchorId: "totokpayterms"
        },
        {
          title: "Privacy Policy",
          anchorId: "totokpayprivacy"
        }
      ]
    };
  },
  computed: {
    info() {
      return [];
    }
  },
  methods: {
    gotoHandle(item) {
      this.isActive = item;
      this.$router.push(item);
    }
  },
  mounted() {
    this.mainPannel = document.getElementById("mainbox");
  }
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .primaryInfo {
        padding: 0.8rem;
        background: #fafafa;
        height: 82vh;

        div {
            margin-left 20px
            margin-right 20px
        }

        .leftMenu {
            display none
        }

        .info {

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 102px;
        width: 100vw;
        background: #fafafa;

        .information {
            margin: 0 auto;
            width: 1024px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                height: 83vh;
                overflow: auto;

                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: center;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 610px;
            margin: 20px 0;

            h1 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
            }

            h2 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            p {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: -apple-system, "Segeo UI", "Helvetica Neue", sans-serif, Oxygen, Roboto;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }


        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
